export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ee5ac73425a4e37d4d2d78f45c12067d5c118177&name=pushAdClickData!'